<header [class]="headerClass">
	<div [class]="containerClass">
		<div [class]="rowClass">
			<div class="col-1 col-md-2 d-flex justify-content-start">
				<ng-container *ngTemplateOutlet="cancelTemplateRef || defaultCancelTemplate"></ng-container>
				<ng-template #defaultCancelTemplate>
					<button
						(click)="cancel()"
						id="cancel"
						class="btn text-dark align-self-center"
						nstarButton
						[ngbTooltip]="cancelTooltip"
						container="body"
						display="dynamic"
						[attr.accesskey]="cancelAccessKey"
					>
						<i nstarIcon>{{ cancelLabel }}</i>
					</button>
				</ng-template>
			</div>
			<div class="col-10 col-md-8 text-center d-flex flex-column justify-content-center">
				<ng-container *ngTemplateOutlet="titleTemplateRef || defaultTitleTemplate"></ng-container>
				<ng-template #defaultTitleTemplate>
					<h1 style="font-size: 1.25em" [class]="titleClass" [innerHTML]="title"></h1>
					<span *ngIf="!!subtitle" class="small" [innerHTML]="subtitle"></span>
				</ng-template>
			</div>
			<div [class]="buttonClass">
				<ng-container *ngTemplateOutlet="buttonTemplateRef"></ng-container>
			</div>
		</div>
	</div>
</header>
